import zxcvbn from 'zxcvbn'

export const validatePassword = (password, confirmPassword) => {
  const rules = [
    { test: pw => /[a-z]/.test(pw), key: 'hasLowercase' },
    { test: pw => /[A-Z]/.test(pw), key: 'hasUppercase' },
    { test: pw => /\d/.test(pw), key: 'hasNumber' },
    { test: pw => /[!@#$%^&*(),.?":{}|<>]/.test(pw), key: 'hasSymbol' },
    { test: pw => pw.length >= 6, key: 'hasCharCount' },
    {
      test: pw => (pw ? zxcvbn(pw).score >= 3 : false),
      key: 'isStrongPassword',
    },
  ]

  const result = rules.reduce((acc, { test, key }) => {
    acc[key] = test(password)
    return acc
  }, {})

  result.passwordsMatch = password === confirmPassword

  return result
}

export const isPasswordValid = validationResult =>
  Object.values(validationResult).every(Boolean)



// WEBPACK FOOTER //
// ./src/common/validatePassword.js